export default __webpack_public_path__ + "static/media/photo--lg--50.74a4ada1.jpg";